export default __webpack_public_path__ + "static/media/Armbands of Tribulation.3eda73a3.jpg";